import { exports as definePropertyExports, __module as defineProperty } from '../../../../_virtual/defineProperty.js';
import { __require as requireToPropertyKey } from './toPropertyKey.js';

var hasRequiredDefineProperty;

function requireDefineProperty () {
	if (hasRequiredDefineProperty) return definePropertyExports;
	hasRequiredDefineProperty = 1;
	(function (module) {
		var toPropertyKey = requireToPropertyKey();
		function _defineProperty(obj, key, value) {
		  key = toPropertyKey(key);
		  if (key in obj) {
		    Object.defineProperty(obj, key, {
		      value: value,
		      enumerable: true,
		      configurable: true,
		      writable: true
		    });
		  } else {
		    obj[key] = value;
		  }
		  return obj;
		}
		module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
} (defineProperty));
	return definePropertyExports;
}

export { requireDefineProperty as __require };
//# sourceMappingURL=defineProperty.js.map
